import { memo, useMemo } from 'react';
import { Link } from 'react-router';
import { Divider, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import {
  SubRoute,
  getListItemTextStyles,
  getNavSubListItemButtonStyles,
  getNavSubListItemDividerStyles,
} from '@shared/components';

interface Props extends SubRoute {
  expandedView: boolean;
  onClick?: () => void;
}

function NavSubItemBase({ to, isActive, title, expandedView, onClick }: Props) {
  const listItemButtonStyles = useMemo(() => getNavSubListItemButtonStyles(), []);
  const listItemDividerStyles = useMemo(() => getNavSubListItemDividerStyles(isActive), [isActive]);
  const listItemTextStyles = useMemo(() => getListItemTextStyles(expandedView), [expandedView]);

  return (
    <ListItem disablePadding>
      <ListItemButton
        to={to}
        component={Link}
        onClick={onClick}
        selected={isActive}
        sx={listItemButtonStyles}
      >
        <Divider orientation="vertical" sx={listItemDividerStyles} />

        <ListItemText
          disableTypography
          primary={<Typography sx={{ fontWeight: isActive ? 600 : 500 }}>{title}</Typography>}
          sx={listItemTextStyles}
        />
      </ListItemButton>
    </ListItem>
  );
}

export const NavSubItem = memo(NavSubItemBase);
